import _extends from "@babel/runtime/helpers/extends";
import { ClassNames } from "@emotion/core";
import React, { forwardRef } from "react";
import { useTheme } from "../../../theme/utils/useTheme";
import { TooltipContainer } from "../components/TooltipContainer";
import { tooltipTheme } from "../tooltipTheme";
const slideTransitionStyles = {
  top: {
    transform: "translateY(4px)"
  },
  bottom: {
    transform: "translateY(-4px)"
  },
  left: {
    transform: "translateX(4px)"
  },
  right: {
    transform: "translateX(-4px)"
  }
};
const extraPaddingStyles = {
  top: "Bottom",
  bottom: "Top",
  left: "Right",
  right: "Left"
};
/**
 * This component's job is to apply the correct animations and border radius to the Tooltip.
 */
export const TooltipFlyoutContainer = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    enterDirection,
    showTransition,
    transitionStatus,
    offset,
    ...props
  } = _ref;
  const {
    key
  } = useTheme();
  const themeMode = key;
  const slideTransition = `transform ${tooltipTheme.motion.slide(themeMode)}`;
  const opacityTransition = `opacity ${tooltipTheme.motion.opacity(themeMode)}`;
  const wrapperSize = () => {
    if (offset) {
      if (enterDirection.includes("top") || enterDirection.includes("bottom")) {
        return offset[1];
      }
      return offset[0];
    }
    return "8";
  };
  return /*#__PURE__*/React.createElement(ClassNames, null, _ref2 => {
    let {
      css
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: css({
        // keeps a buffer on all sides at 8px unless overriden by offset
        padding: `8px`,
        ...(enterDirection !== "auto" ? {
          [`padding${extraPaddingStyles[enterDirection]}`]: `${wrapperSize()}px`,
          [`margin${extraPaddingStyles[enterDirection]}`]: `-${wrapperSize()}px`
        } : {})
      })
    }, /*#__PURE__*/React.createElement(TooltipContainer, _extends({}, props, {
      ref: ref,
      className: css({
        opacity: transitionStatus === "entered" ? 1 : 0,
        transform: transitionStatus === "entering" && enterDirection !== "auto" ? slideTransitionStyles[enterDirection].transform : "translateY(0) translateX(0)",
        // Always show opacity, slide transition nees to happen AFTER the first popper update.
        transition: `${opacityTransition}, ${showTransition ? slideTransition : ""}`
      })
    }), children));
  });
});
TooltipFlyoutContainer.displayName = "TooltipFlyoutContainer";
//# sourceMappingURL=TooltipFlyoutContainer.js.map